/*global angular */
/*jslint node: true */

'use strict';

var logo = angular.module('logo', []);
logo.directive('logoSlot', ['$templateCache', function ($templateCache) {
    return {
        restrict: 'E',
        template: $templateCache.get('slots/logo/logo.html')
    };
}]);
